<template>
  <div>
    <Page title="タグ管理">
      <template v-slot:content>
        <div class="tags-container">
          <div>
            <h5>
              タグ新規登録
              <HelpIcon
                tooltipText="タグ名の長さは15文字以内で入力してください"
                position="top-left"
                cls="uk-active uk-width-auto"
              />
            </h5>
          </div>
          <img
            v-if="!isOpenNewTagForm"
            src="@/assets/image/plus.png"
            class="uk-margin-small-left plus-icon"
            @click="openNewTagForm"
          />
          <div v-if="isOpenNewTagForm" class="tag" :style="{ background: nextColor }">
            <input type="text" class="uk-input" v-model="newTagName" />
            <button
              uk-icon="icon: check; ratio: 0.8"
              class="uk-margin-small-right uk-margin-small-left"
              @click="addTag"
              :disabled="!newTagName"
            ></button>
            <button uk-icon="icon: close; ratio: 0.8" @click="closeNewTagForm"></button>
          </div>
          <h5>登録済みタグ</h5>
          <div class="tag-list">
            <div class="tag-flex-container">
              <div class="tag" v-for="tag in tags" :key="tag.id" :style="{ background: tag.color }">
                <input v-if="!tag.inEdit" type="checkbox" v-model="tag.selected" :id="tag.tagId" />
                <label v-if="!tag.inEdit" :for="tag.tagId">{{ tag.name }}</label>
                <button
                  v-if="!tag.inEdit"
                  uk-icon="icon: file-edit; ratio: 0.8"
                  class="uk-margin-small-right uk-margin-small-left"
                  :disabled="inEditTag"
                  @click="editTag(tag)"
                />
                <button v-if="!tag.inEdit" uk-icon="icon: trash; ratio: 0.8" :disabled="inEditTag" @click="deleteTag(tag)" />
                <input v-if="tag.inEdit" class="uk-input" type="text" v-model="tag.name" />
                <button
                  v-if="tag.inEdit"
                  uk-icon="icon: check; ratio: 0.8"
                  class="uk-margin-small-right uk-margin-small-left"
                  @click="confirmEditTag(tag)"
                />
                <button v-if="tag.inEdit" uk-icon="icon: close; ratio: 0.8" @click="cancelEdit(tag)" />
              </div>
            </div>
          </div>
          <h5>検索</h5>
          <div class="search-employee">
            <div class="header">
              <div class="user-type">
                <input id="employee" type="radio" name="type" v-model="userType" v-on:change="onSearch" value="employee" />
                <label for="employee">従業員</label>
                <input
                  id="applicant"
                  type="radio"
                  class="uk-margin-left"
                  name="type"
                  v-model="userType"
                  v-on:change="onSearch"
                  value="applicant"
                />
                <label for="applicant">応募者</label>
              </div>
              <div class="right-contents">
                <Field name="departmentId" class="search-box">
                  <label class="item-name ">名前</label>
                  <input class="uk-input search-box" type="text" v-model="userName" placeholder="中間一致" />
                  <label class="item-name">部署</label>
                  <select class="uk-select" v-model="department">
                    <option value="all"></option>
                    <option
                      v-for="department in storeInstance.getShortDepartmentsList({})"
                      :key="department.id"
                      :value="department.id"
                    >
                      {{ department.name }}
                    </option>
                  </select>
                </Field>
                <div class="buttons">
                  <ActionButton title="検索" color="primary" type="submit" :width="110" @click="onSearch" />
                  <ActionButton title="クリア" color="default" type="submit" :width="110" @click="onClear" />
                  <ActionButton
                    class="uk-margin-medium-left"
                    title="タグを付与 "
                    color="primary"
                    type="submit"
                    :width="160"
                    @click="attachTag"
                    :disabled="disableAttachTags"
                  />
                </div>
              </div>
            </div>
            <div class="content uk-margin-top">
              <div class="uk-card uk-card-default uk-card-body">
                <table class="uk-table uk-table-divider">
                  <thead>
                    <tr>
                      <th
                        v-for="item in header"
                        :key="item.key"
                        @click="sortBy(item.key, item.type)"
                        :class="[`uk-table-${item.width}`, { 'uk-text-nowrap': item.width === 'shrink' }]"
                        :style="{
                          width: `${Number.isInteger(item.width) ? item.width + 'px' : false}`
                        }"
                      >
                        <template v-if="item.type === 'selection'">
                          <input type="checkbox" v-model="item.checked" @change="onSelectionAllChange($event)" />
                        </template>
                        <template v-else-if="item.type !== 'button'">
                          {{ item.title }}
                        </template>
                        <span
                          v-if="item.type === 'text' && item.key === lastSortedKey"
                          :uk-icon="sortOrders[item.key] > 0 ? 'arrow-up' : 'arrow-down'"
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(participant, index) in filteredParticipants" :key="index">
                      <td v-for="col in header" :key="col.key" class="col">
                        <template v-if="col.type === 'tag'">
                          <div :style="col.tagStyle">
                            <div
                              class="tag"
                              v-for="(tag, tagIndex) in participant[col.key]"
                              :key="tagIndex"
                              :style="{ background: tag.color }"
                            >
                              {{ tag.name }}
                              <button
                                uk-icon="icon: close; ratio: 0.8"
                                @click="detachTag(participant[col.key][tagIndex].id, participant.id)"
                              />
                            </div>
                          </div>
                        </template>
                        <template v-else-if="col.type === 'selection'">
                          <input
                            type="checkbox"
                            :disabled="col.disabled && col.disabled(participant)"
                            :value="true"
                            :checked="participant.selected"
                            @change="onSelectionChange($event, participant.orgIndex)"
                          />
                        </template>
                        <template v-else-if="col.type === 'button'">
                          <TableActionButton
                            :title="col.title"
                            color="primary"
                            :disabled="!isReadableUserStats || !participant.tested"
                            @click.stop="onColumnClick(participant.orgIndex, col.key, $event)"
                            :width="Number.isInteger(col.width) ? col.width : 0"
                          />
                        </template>
                        <template v-else>
                          <div v-for="str in (participant[col.key] || '').split('\n')" :key="str">
                            {{ str }}
                          </div>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <VueEternalLoading :load="load" margin="300px">
                  <template #loading="{ isFirstLoad }">
                    <template v-if="isFirstLoad">
                      データ取得中です
                    </template>
                    <template v-else>
                      読み込み中...
                    </template>
                  </template>
                  <template #no-more>データをすべて表示しました</template>
                  <template #no-results>データはありません</template>
                </VueEternalLoading>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Page>
  </div>
</template>
<style lang="scss" scoped>
.tags-container {
  .col {
    vertical-align: middle !important;
  }

  .plus-icon {
    cursor: pointer;
  }

  margin: 20px 20px;
  h5 {
    font-weight: bold;
  }
  .tag {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    padding-right: 10px;
    margin: 6px 6px;
    height: 36px;
    font-weight: bold;
    width: fit-content;
    > input {
      height: 26px;
      font-size: 16px;
      margin-left: 6px;
    }
  }
  > .tag-list {
    overflow-y: scroll;
    height: 120px;
    border: 1px solid #bbb;
    margin: 0 6px;
    > .tag-flex-container {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
    }
  }
  > .search-employee {
    > .header {
      display: flex;
      align-items: center;
      flex-direction: row;
      > input {
        vertical-align: middle;
      }
      > label {
        font-size: 16px;
        vertical-align: middle;
      }
    }
    .content {
      :deep(.tag) {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 8px;
        padding: 0 10px;
        margin: 6px 6px;
        height: 36px;
        width: fit-content;
        font-weight: bold;
      }
    }
    .right-contents {
      display: flex;
      align-items: center;
      flex-direction: row;
      margin: 0 0 0 auto;
      .buttons {
        & > button:first-child {
          margin-right: 6px;
        }
      }
      > input {
        vertical-align: middle;
      }
      > .search-box {
        display: flex;
        box-sizing: border-box;
        align-items: center;
        margin-right: $spacing-ex-small;
        width: 40em;
        margin-left: 20px;
        > .item-name {
          margin-left: 26px;
          margin-right: 10px;
          min-width: 35px;
        }
      }
      > label {
        font-size: 16px;
        vertical-align: middle;
      }
    }
  }
}
.uk-icon[uk-icon="arrow-up"] {
  color: #cf51b4;
}
.uk-icon[uk-icon="arrow-down"] {
  fill: #57ac6f;
}
</style>

<script lang="ts">
import FormMixin from "../../helpers/mixins/form";
import { Options } from "vue-class-component";
import Store from "../../store";
import Page from "../molecules/Page.vue";
import TableActionButton from "../atoms/TableActionButton.vue";
import SearchField from "../atoms/SearchField.vue";
import ActionButton from "../atoms/ActionButton.vue";
import HelpIcon from "../atoms/HelpIcon.vue";
import { InstructionLevel } from "../../types";
import {
  SystemApi,
  DepartmentApi,
  GetEmployeeProfile,
  GetApplicantProfile,
  ApplicantApi,
  UserTypeEnum,
  AttachTag,
  DetachTag
} from "../../autogen";
import { VueEternalLoading, LoadAction } from "@ts-pro/vue-eternal-loading";

type Tag = {
  tagId: string;
  name: string;
  inEdit: boolean;
  selected: boolean;
  color?: string;
};

@Options({
  components: {
    Page,
    SearchField,
    ActionButton,
    TableActionButton,
    VueEternalLoading,
    HelpIcon
  }
})
export default class Tags extends FormMixin {
  isOpenNewTagForm = false;
  memory = "";
  newTagName = "";
  formName = "タグ";
  userType: UserTypeEnum = UserTypeEnum.Employee;
  userName: string = "";
  department: string = "all";
  colors = ["#b9dff8", "#bef59c", "#ffd76c", "#f5fe01", "#ffd1cb", "#9ddaff", "#86e08c", "#ffb900", "#ffeb00", "#ffa99d"];
  tags: Tag[] = [];
  pageSize = 100;
  participants: { [key: string]: any }[] = [];
  header = [
    { sortable: true, key: "expand", width: "shrink", type: "selection" },
    { title: "名前", sortable: true, key: "name", width: "small" },
    { title: "部署", sortable: true, key: "departmentName", width: "small" },
    { title: "職種", sortable: true, key: "occupationName", width: "small" },
    {
      title: "付与済みタグ",
      key: "tags",
      width: 750,
      type: "tag",
      tagStyle: { display: "flex", flexWrap: "wrap" }
    },
    { title: "受検結果", type: "button", key: "result", width: 120 }
  ];
  inEdit: boolean = false;
  isReadableUserStats: boolean = false;
  sortKey: string = "";
  sortOrders: { [key: string]: number } = {};
  lastSortedKey: string = "";

  get nextColor(): string {
    return this.colors[this.tags.length % 10];
  }
  get inEditTag(): boolean {
    return this.tags.some(tag => tag.inEdit);
  }
  get disableAttachTags() {
    return (
      this.participants.filter(participant => participant.selected).length === 0 ||
      this.tags.filter(tag => tag.selected).length === 0
    );
  }
  async beforeMount() {
    this.checkReadableUserStats();
  }
  async mounted() {
    if (this.header) {
      this.header.forEach(head => {
        if (head.key) this.sortOrders[head.key] = 1;
        if (!head.type) head.type = "text";
      });
    }
    await this.fetchTags();
    this.fetchTableData();
  }
  get filteredParticipants() {
    let sortKey = this.sortKey;
    let order = this.sortOrders[sortKey] || 1;
    let participants = this.participants;
    participants = participants.map((d, index: number) => ({
      orgIndex: index,
      ...d
    }));
    if (sortKey && participants) {
      participants = participants.slice().sort((a, b) => {
        a = a[sortKey];
        b = b[sortKey];
        return (a === b ? 0 : a > b ? 1 : -1) * order;
      });
    }
    return participants;
  }
  checkReadableUserStats() {
    this.isReadableUserStats =
      this.userType === UserTypeEnum.Employee ? this.$role.isReadable("employeeStats") : this.$role.isReadable("applicantStats");
  }

  getTagColor(tag: Tag) {
    return this.colors[this.tags.findIndex(t => t.tagId === tag.tagId) % 10];
  }
  onSearch(): void {
    this.fetchTableData();
    this.checkReadableUserStats();
  }
  onClear(): void {
    this.userType = UserTypeEnum.Employee;
    this.userName = "";
    this.department = "all";
  }
  openNewTagForm() {
    this.isOpenNewTagForm = true;
  }
  closeNewTagForm() {
    this.isOpenNewTagForm = false;
    this.newTagName = "";
  }
  async addTag() {
    try {
      await new SystemApi().createTag({
        createTag: { name: this.newTagName, type: "person" }
      });
      this.fetchTags();
      this.isOpenNewTagForm = false;
      this.newTagName = "";
      Store.getInstance().setInstructionContent(InstructionLevel.Info, "タグを更新しました");
    } catch (err) {
      let errMessage = "エラーが発生しました";
      if (err.response && err.response.data) {
        errMessage = err.response.data.detail;
      }
      Store.getInstance().setInstructionContent(InstructionLevel.Alert, errMessage);
    }
  }
  editTag(tag: Tag): void {
    this.memory = tag.name;
    tag.inEdit = true;
  }
  cancelEdit(tag: Tag): void {
    tag.name = this.memory;
    this.memory = "";
    tag.inEdit = false;
  }
  async confirmEditTag(tag: Tag) {
    if (tag.name === this.memory) {
      this.memory = "";
      tag.inEdit = false;
      return;
    }
    try {
      await new SystemApi().updateTag({
        tagId: tag.tagId,
        updateTag: { name: tag.name, type: "person" }
      });
      tag.inEdit = false;
      this.fetchTableData();
      Store.getInstance().setInstructionContent(InstructionLevel.Info, "タグを更新しました");
    } catch (err) {
      let errMessage = "エラーが発生しました";
      if (err.response && err.response.data) {
        errMessage = err.response.data.detail;
      }
      Store.getInstance().setInstructionContent(InstructionLevel.Alert, errMessage);
    }
  }
  async deleteTag(tag: Tag) {
    this.onDelete(async () => {
      await new SystemApi().deleteTag({
        tagId: tag.tagId
      });
      this.fetchTags();
      this.fetchTableData();
    }, "タグを削除します。よろしいでしょうか？\n※従業員、応募者に付与したタグも全て削除されます。");
  }
  async attachTag() {
    const selectedTags = this.tags.filter(tag => tag.selected);
    const selectedUsers = this.participants.filter(participant => participant.selected);
    selectedUsers.map(user => user.id);
    let attachTag: AttachTag = { tagIds: selectedTags.map(tag => tag.tagId) };
    if (this.userType === UserTypeEnum.Employee) {
      attachTag.employeeIds = selectedUsers.map(user => user.id);
    } else if (this.userType === UserTypeEnum.Applicant) {
      attachTag.applicantIds = selectedUsers.map(user => user.id);
    }

    try {
      const response = await new SystemApi().attachTag({
        attachTag
      });
      if (response.data && response.data.message) {
        if (response.data.name_list && response.data.name_list.length > 0) {
          Store.getInstance().setInstructionContent(
            InstructionLevel.Alert,
            response.data.message + "\n" + response.data.name_list.join(", ")
          );
        } else {
          Store.getInstance().setInstructionContent(InstructionLevel.Info, response.data.message);
        }
      }
      this.fetchTableData();
    } catch (err) {
      let errMessage = "エラーが発生しました";
      if (err.response && err.response.data) {
        errMessage = err.response.data.detail;
      }
      Store.getInstance().setInstructionContent(InstructionLevel.Alert, errMessage);
    }
  }
  async detachTag(tagId: string, userId: string) {
    let detachTag: DetachTag = {};
    if (this.userType === UserTypeEnum.Employee) {
      detachTag.employeeIds = [userId];
    } else if (this.userType === UserTypeEnum.Applicant) {
      detachTag.applicantIds = [userId];
    }
    try {
      this.onDelete(async () => {
        await new SystemApi().detachTag({
          tagId,
          detachTag
        });
        this.fetchTableData();
      }, "タグを除去します。よろしいでしょうか？");
    } catch (err) {
      let errMessage = "エラーが発生しました";
      if (err.response && err.response.data) {
        errMessage = err.response.data.detail;
      }
      Store.getInstance().setInstructionContent(InstructionLevel.Alert, errMessage);
    }
  }

  sortBy(key: string, type: string) {
    if (type !== "text") return;
    this.sortKey = key;
    this.sortOrders[key] = this.sortOrders[key] * -1;
    this.lastSortedKey = key;
  }

  onSelectionChange(event: Event, index: number) {
    const target = event.target as HTMLInputElement;
    this.participants[index].selected = target.checked;
  }
  onSelectionAllChange(event: Event) {
    const target = event.target as HTMLInputElement;
    if (this.participants) {
      this.participants.forEach(participant => {
        participant.selected = target.checked;
      });
    }
  }
  async fetchTags() {
    try {
      const tags = await new SystemApi().getTags({
        type: "person"
      });
      this.tags = tags.data.map((tag, index) => ({
        tagId: tag.tagId!,
        name: tag.name!,
        inEdit: false,
        selected: false,
        color: this.colors[index % 10]
      }));
    } catch (err) {
      let errMessage = "エラーが発生しました";
      if (err.response && err.response.data) {
        errMessage = err.response.data.detail;
      }
      Store.getInstance().setInstructionContent(InstructionLevel.Alert, errMessage);
    }
  }
  async fetchTableData() {
    let response;
    try {
      if (this.userType === UserTypeEnum.Employee) {
        response = await new DepartmentApi().getEmployees(
          Object.assign({
            limit: "100",
            name: this.userName ? this.userName : undefined,
            departmentId: this.department
          })
        );

        this.participants = (response.data.lists as GetEmployeeProfile[]).map(datum =>
          Object.assign(datum, {
            name: `${datum.lastName} ${datum.firstName}`,
            department: datum.department,
            departmentName: datum.department?.name || "-",
            occupationName: datum.occupation?.name || "-",
            tags: datum.tags
              ? datum.tags.map((tag, index) => ({
                  id: tag.id,
                  name: tag.name,
                  color: this.tags.find(t => t.tagId === tag.id)!.color
                }))
              : [],
            selected: false,
            tested: datum.lastExamDate ? true : false
          })
        );
      } else if (this.userType === UserTypeEnum.Applicant) {
        response = await new ApplicantApi().getApplicants(
          Object.assign({
            limit: "100",
            name: this.userName ? this.userName : undefined,
            departments: this.department?.length ? this.department : undefined
          })
        );

        this.participants = (response.data.lists as GetApplicantProfile[]).map(datum =>
          Object.assign(datum, {
            name: `${datum.lastName} ${datum.firstName}`,
            department: datum.department,
            departmentName: datum.department?.name || "-",
            occupationName: datum.occupation?.name || "-",
            tags: datum.tags
              ? datum.tags.map((tag, index) => ({ id: tag.id, name: tag.name, color: this.colors[index % 10] }))
              : [],
            selected: false,
            tested: datum.lastExamDate ? true : false
          })
        );
      }
    } catch (err) {
      let errMessage = "エラーが発生しました";
      if (err.response && err.response.data) {
        errMessage = err.response.data.detail;
      }
      Store.getInstance().setInstructionContent(InstructionLevel.Alert, errMessage);
    }
  }
  async load(action: LoadAction): Promise<any> {
    if (!this.participants) return;
    const loadedData = this.participants.slice(this.participants.length, this.participants.length + this.pageSize);
    if (loadedData.length) {
      const _sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
      await _sleep(350);
      this.participants.push(...loadedData);
      action.loaded(this.participants.length, this.pageSize);
    } else {
      action.noMore();
    }
  }
  async onColumnClick(index: number, key: string, event: Event) {
    const rowData = this.participants[index];
    const location = { row: index, col: key, el: event && event.target, rowData };
    if (location.col === "result" && location.rowData) {
      this.$router.push({
        name: this.userType === UserTypeEnum.Employee ? "EmployeeStats" : "ApplicantStats",
        params: {
          clientId: this.$route.params["clientId"],
          peopleId: location.rowData.id
        }
      });
    }
  }
}
</script>
